// @flow

import type { PendingIncomingPayment } from './types';

export function getBoletoBarcodeRaw(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['boleto_barcode_raw'];
}
